import { useMemo } from "react";


const sumRows = (rows) => {
    return rows.reduce((acc, row) => {
        for (let key in row) {
          const currentValue = Number(row[key]);
          if (!Number.isNaN(currentValue)) {
            const accValue = acc[key] ?? 0;
            acc[key] = accValue + currentValue;
            continue
          }
          acc[key] = currentValue;
        }
        return acc
    }, {})
}

const getFooterTemplate = (selectValue, total, unit) => {
 return `${selectValue ? selectValue + " / " : ''} ${total} ${unit}`
}

const getFooterValue = (value = '', show) => {
    if (!show) {
      return ''
    }

    const isFloatNumber = typeof value === "number" && value % 1 !== 0
    return isFloatNumber ? value.toFixed(2) : value ?? ''
}

const useFooter = (rowsData, selectedRows, columns) => {
  const computedTotals = useMemo(() => {
    return sumRows(rowsData)
  }, [rowsData]);

  const selectedTotals = useMemo(() => {
    return sumRows(selectedRows)
  }, [selectedRows]);


  const footer = useMemo(() => {

    return columns.reduce((acc, column) => {
        const {accessorKey, meta} = column
        const currentSelectedValue = getFooterValue(selectedTotals[accessorKey],  meta?.summable)
        const currentTotalValue = getFooterValue(computedTotals[accessorKey],  meta?.summable)
        const currentUnit = getFooterValue(meta.unit, currentTotalValue)
        acc[accessorKey] = getFooterTemplate(currentSelectedValue, currentTotalValue, currentUnit)

        return acc
    }, {})
    
    
  }, [columns, computedTotals, selectedTotals])


  return footer

};

export default useFooter;
